export default class extends HTMLElement {
  connectedCallback () {
    this.targetEl = this.target

    if (this.targetEl) {
      this.input.value = this.targetEl.value

      this.targetEl.addEventListener('input', this.sync)
      this.targetEl.addEventListener('linked-input.update', this.sync)
    }
  }

  disconnectedCallback () {
    // Remove os listeners do elemento-alvo (que sobrevive a este <linked-input>) para
    // não acumular handlers a cada add/remove de signatário ou navegação.
    this.targetEl?.removeEventListener('input', this.sync)
    this.targetEl?.removeEventListener('linked-input.update', this.sync)
  }

  sync = (e) => {
    this.input.value = e.target.value
  }

  get input () {
    return this.querySelector('input')
  }

  get target () {
    if (this.dataset.targetId) {
      const listItem = this.closest('[data-targets="dynamic-list.items"]')

      if (listItem) {
        return listItem.querySelector(`#${this.dataset.targetId}`)
      } else {
        return document.getElementById(this.dataset.targetId)
      }
    }
  }
}
